module.exports = __webpack_public_path__ + "static/media/popupNavy.e4c0d013.svg";